const cards = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=A%20dramatic%20sci-fi%20movie%20scene%20with%20astronauts%20floating%20near%20a%20massive%20space%20station%2C%20warm%20golden%20nebula%20in%20background%2C%20cinematic%20lighting%20with%20strong%20contrast%2C%20epic%20atmosphere%2C%20film%20grain%20texture%2C%20professional%20movie%20still%20photography&width=800&height=600&seq=card-movie-01&orientation=landscape",
    title: "流浪地球3",
    tag: "科幻巨制",
    meta: "2026 · 动作 / 科幻",
    desc: "人类命运共同体再度集结，跨越星系寻找新家园的壮丽史诗。",
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20drama%20scene%20with%20a%20couple%20standing%20under%20cherry%20blossoms%20at%20sunset%2C%20soft%20warm%20golden%20hour%20lighting%2C%20emotional%20and%20tender%20mood%2C%20beautiful%20cinematic%20composition%2C%20film-like%20color%20grading%20with%20dreamy%20atmosphere&width=800&height=600&seq=card-movie-02&orientation=landscape",
    title: "眼泪女王",
    tag: "韩剧热播",
    meta: "2026 · 爱情 / 剧情",
    desc: "豪门千金与平凡律师笑泪交织的爱情故事，豆瓣高分推荐。",
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=A%20historical%20Chinese%20costume%20drama%20scene%20with%20elaborate%20ancient%20palace%20interior%2C%20warm%20candlelight%20and%20lantern%20glow%2C%20intricate%20silk%20robes%2C%20mysterious%20atmosphere%2C%20cinematic%20photography%20with%20rich%20amber%20and%20gold%20tones&width=800&height=600&seq=card-movie-03&orientation=landscape",
    title: "庆余年2",
    tag: "古装权谋",
    meta: "2026 · 古装 / 悬疑",
    desc: "范闲归来，朝堂风云再起，权谋与情感交错的全新篇章。",
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=A%20mysterious%20supernatural%20thriller%20scene%20with%20a%20group%20of%20teenagers%20exploring%20a%20dark%20forest%20with%20flashlights%2C%20eerie%20warm%20glow%20in%20distance%2C%20cinematic%20horror%20aesthetic%2C%20foggy%20atmosphere%2C%20suspenseful%20mood%2C%20professional%20film%20still&width=800&height=600&seq=card-movie-04&orientation=landscape",
    title: "怪奇物语5",
    tag: "美剧经典",
    meta: "2026 · 悬疑 / 科幻",
    desc: "霍金斯小镇终极对决，颠倒世界秘密全面揭晓。",
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=A%20Japanese%20anime%20style%20scene%20with%20a%20warrior%20holding%20a%20katana%20in%20a%20moonlit%20bamboo%20forest%2C%20dramatic%20warm%20lighting%20with%20fireflies%2C%20cinematic%20anime%20aesthetic%2C%20rich%20deep%20colors%20and%20dynamic%20composition&width=800&height=600&seq=card-movie-05&orientation=landscape",
    title: "鬼灭之刃",
    tag: "热血动漫",
    meta: "2026 · 动画 / 战斗",
    desc: "炭治郎在最终决战中直面鬼舞辻无惨，全员集结的史诗战役。",
  },
  {
    id: 6,
    image: "https://readdy.ai/api/search-image?query=A%20variety%20show%20scene%20with%20a%20group%20of%20celebrities%20running%20and%20laughing%20on%20an%20outdoor%20adventure%20course%2C%20bright%20warm%20sunlight%2C%20energetic%20and%20joyful%20atmosphere%2C%20reality%20TV%20cinematic%20style%20with%20vibrant%20colors&width=800&height=600&seq=card-movie-06&orientation=landscape",
    title: "奔跑吧·第8季",
    tag: "热门综艺",
    meta: "2026 · 综艺 / 真人秀",
    desc: "全新阵容开启户外挑战之旅，笑料不断欢乐满载。",
  },
  {
    id: 7,
    image: "https://readdy.ai/api/search-image?query=A%20stunning%20nature%20documentary%20scene%20with%20a%20polar%20bear%20family%20on%20arctic%20ice%20under%20the%20northern%20lights%2C%20breathtaking%20warm%20aurora%20colors%2C%20cinematic%20wildlife%20photography%2C%20majestic%20and%20serene%20atmosphere&width=800&height=600&seq=card-movie-07&orientation=landscape",
    title: "地球脉动3",
    tag: "纪录大片",
    meta: "2026 · 纪录 / 自然",
    desc: "穿越七大洲四大洋，用镜头记录地球最震撼的生命奇迹。",
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-900">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 font-bold mb-3">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-400 max-w-lg mx-auto">
              每日精选热播影视佳作，为您推荐最值得看的免费电影与电视剧
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {cards.map((card, idx) => (
              <article
                key={card.id}
                className="group bg-background-800/60 border border-background-700/40 rounded-xl overflow-hidden hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={card.image}
                    alt={`爱看影院 — ${card.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading={idx < 4 ? 'eager' : 'lazy'}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-background-950/75 backdrop-blur-sm text-xs text-primary-300 border border-primary-500/20">
                      {card.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-base text-foreground-100 font-bold mb-1 group-hover:text-primary-400 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-xs text-foreground-400 mb-2">{card.meta}</p>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}